import { useEffect, useState } from 'react';
import { usePlaidLink } from 'react-plaid-link';
import { useTheme } from '../context/ThemeContext';
import { exchangeToken, syncPlaid } from '../api/client';

const LINK_TOKEN_KEY = 'ledger_plaid_link_token';

// Fidelity (and other OAuth brokerages) bounce back here after login. We resume
// Link with the stored token + the full return URL, then send the user to Settings.
const PlaidOAuthReturn = () => {
  const { COLORS } = useTheme();
  const [status, setStatus] = useState('Connecting your account…');
  const [failed, setFailed] = useState(false);
  const token = typeof window !== 'undefined' ? localStorage.getItem(LINK_TOKEN_KEY) : null;
  const receivedRedirectUri = typeof window !== 'undefined' ? window.location.href : undefined;

  const { open, ready } = usePlaidLink({
    token,
    receivedRedirectUri: token ? receivedRedirectUri : undefined,
    onSuccess: async (public_token) => {
      try {
        setStatus('Saving connection…');
        await exchangeToken(public_token);
        await syncPlaid(true);
        localStorage.removeItem(LINK_TOKEN_KEY);
        setStatus('Connected. Redirecting…');
        window.location.replace('/#/settings');
      } catch (err) {
        console.error('Plaid OAuth exchange failed:', err);
        setFailed(true);
        setStatus('Connected at the bank, but saving failed. Open Settings and try again.');
      }
    },
    onExit: (err) => {
      if (err) console.error('Plaid OAuth exit:', err);
      localStorage.removeItem(LINK_TOKEN_KEY);
      const msg = err?.display_message || err?.error_message || err?.error_code;
      window.location.replace(msg
        ? `/#/settings?plaid_error=${encodeURIComponent(msg)}`
        : '/#/settings');
    },
  });

  useEffect(() => {
    if (!token) {
      setFailed(true);
      setStatus('Link session expired. Go back to Settings and connect again.');
      return;
    }
    if (ready) open();
  }, [ready, token, open]);

  return (
    <div style={{ minHeight: '100vh', background: COLORS.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, fontFamily: "'DM Sans', sans-serif" }}>
      <div style={{ textAlign: 'center', maxWidth: 360 }}>
        <div style={{ color: failed ? COLORS.red : COLORS.text, fontSize: 16, fontWeight: 700, marginBottom: 10 }}>{status}</div>
        {failed && (
          <a href="/#/settings" style={{ color: COLORS.accent, fontWeight: 700, fontSize: 14 }}>Back to Settings</a>
        )}
      </div>
    </div>
  );
};

export default PlaidOAuthReturn;
export { LINK_TOKEN_KEY };
